import { User } from '../types'
import { create } from 'zustand'

// Define the store's state
type UserState = {
  user: User | undefined
  setUser: (user: User) => void
  unsetUser: () => void
}

const getUserFromStorage = (): User | undefined => {
  try {
    const raw = localStorage.getItem('user')
    return raw ? JSON.parse(raw) : undefined
  } catch {
    return undefined
  }
}

// Create the store
export const useUserStore = create<UserState>((set) => ({
  user: getUserFromStorage(),
  setUser: (user) => set({ user }),
  unsetUser: () => set({ user: undefined }),
}))
